
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/all-certification-vouchers",
      function () {
        return require("private-next-pages/all-certification-vouchers/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/all-certification-vouchers"])
      });
    }
  